import Homebutton from "../Homebutton";

function Cuf() {
  return (
    <div className='container'>
      <div className='container-box'>
        <h1 className='text-center'>CUF migratie</h1>
        <h2 className='text-center'>Wat houdt een CUF migratie in?</h2>
        <p>
          Bij een CUF migratie wordt de klant van het kopernet omgezet naar het
          fiber net. Hierbij wordt rekening gehouden met de situatie van de
          klant hoe het is op het moment dat de dienst nog op het kopernet zat
          aangesloten. Mocht er aanpassingen gedaan moeten worden om deze
          situatie in stand te houden dan is dat vaak kosteloos. Het is vaak
          onduidelijk wat wel of niet berekend moet worden naar de klant hier
          wordt later richtlijnen aangeboden om het zo duidelijk mogelijk te
          maken.
        </p>
        <p>
          <br />
        </p>
        <Homebutton />
      </div>
    </div>
  );
}

export default Cuf;
